module.exports = __webpack_public_path__ + "static/media/maxcdn.84906f59.svg";